<div 
    [style.width.%]="loaderWidth"
    [style.height.vh]="loaderHeight"
    [style.width.rem]="loaderWidthRem"
    [style.margin-top.px]="marginTop"
    [style.margin-left.px]="marginLeft"
    [style.margin-right.px]="marginRight"
    [style.margin-bottom.px]="marginBottom"
    [style.padding.px]="padding"
    [class]="loaderType === 'linear' ? 'linear-loader' : 'circular-loader'"
>
    <div [class] = "loaderType === 'linear' ? 'linear-pot' : 'circular-pot'">
    </div>
</div>